import { useState } from "react";
import "../assets/css/managementTeam.css";

import mdImage from "../assets/img/Israel.png";
import creditHeadImage from "../assets/img/Isaac.png";

type ManagementMember = {
  name: string;
  role: string;
  image: string;
  bio: string;
  details: string;
  expertise: string[];
};

const managementTeam: ManagementMember[] = [
  {
    name: "Oyinloye Joseph Esharena",

    // ✅ FIXED ROLE
    role: "Managing Director (MD)",

    image: mdImage,
    bio: "Provides strategic leadership and oversees GMT Technologies Limited’s financial technology operations.",
    details:
      "Oyinloye Joseph Esharena is a results-driven business and finance professional with strong experience in financial services, brand growth, and operational strategy. He holds an HND in Banking and Finance from Delta State Polytechnic, Ozoro (now Delta State University of Science and Technology).\n\nHe began his journey with a strong entrepreneurial foundation in wholesale beverage trading before transitioning into the financial sector. At Mutual Trust Microfinance Bank, he progressed to the role of Profit Center Manager (PCM), where he played a key role in driving business growth through strategic initiatives and customer-focused engagement.\n\nAs Managing Director of GMT Technologies Limited, he provides strategic direction, oversees company operations, and drives innovation in delivering technology-driven lending and financial solutions.",
    expertise: [
      "Strategic Leadership",
      "Business Growth",
      "Financial Services",
      "Customer Engagement",
      "Operations Oversight",
    ],
  },
  {
    name: "Breakforth Isaac",
    role: "Chief Operating Officer (COO)",
    image: creditHeadImage,
    bio: "Finance professional with strong expertise in credit operations, risk management, and fintech execution.",
    details:
      "Mr. Breakforth Isaac is a seasoned finance professional with a strong academic and practical background in accounting, finance, and risk management. He holds a Bachelor's degree in Accounting from Veritas University, Abuja, and is currently pursuing an MBA at Ahmadu Bello University (ABU), alongside a Master’s degree in Finance and Investment.\n\nHe is a Certified Project Manager (Institute of Management, Berlin) and a Chartered Member of the Institute of Loan and Risk Management of Nigeria. His career began at Platinum Mortgage Bank and advanced at Mutual Trust Microfinance Bank, where he rose to Team Lead, Credit Support Department. There, he implemented innovative credit strategies and leveraged technology to enhance loan origination, monitoring, and recovery, significantly improving operational efficiency and portfolio performance.\n\nHe currently serves as Chief Operating Officer (COO) and Board Member at GMT Technologies Limited, where he oversees operations, strategic execution, and organizational growth.",
    expertise: [
      "Credit Risk Management",
      "Loan Operations",
      "Fintech Strategy",
      "Project Management",
      "Portfolio Growth",
    ],
  },
];

export default function ManagementTeam() {
  const [selectedMember, setSelectedMember] =
    useState<ManagementMember | null>(null);

  return (
    <main className="management-page">
      <section className="management-hero">
        <span className="management-eyebrow">Our Leadership</span>

        <h1>Management Team</h1>

        <p>
          Meet the experienced professionals driving GMT Technologies Limited’s
          mission to deliver trusted, technology-driven lending and financial
          services.
        </p>

        <div className="management-hero-stats">
          <div>
            <strong>Fintech</strong>
            <span>Driven Operations</span>
          </div>

          <div>
            <strong>Risk</strong>
            <span>Controlled Lending</span>
          </div>

          <div>
            <strong>Trust</strong>
            <span>Transparent Leadership</span>
          </div>
        </div>
      </section>

      <section className="management-grid">
        {managementTeam.map((member, index) => (
          <article className="management-card" key={index}>
            <div className="management-image">
              <img src={member.image} alt={member.name} />
            </div>

            <div className="management-info">
              <span className="management-role">{member.role}</span>
              <h3>{member.name}</h3>
              <p>{member.bio}</p>

              <button
                type="button"
                className="management-profile-btn"
                onClick={() => setSelectedMember(member)}
              >
                View Profile
              </button>
            </div>
          </article>
        ))}
      </section>

      {selectedMember && (
        <div
          className="management-modal-overlay"
          onClick={() => setSelectedMember(null)}
        >
          <div
            className="management-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="management-modal-close"
              onClick={() => setSelectedMember(null)}
            >
              ×
            </button>

            <div className="management-modal-image">
              <img src={selectedMember.image} alt={selectedMember.name} />
            </div>

            <div className="management-modal-content">
              <span>{selectedMember.role}</span>
              <h2>{selectedMember.name}</h2>
              <p>{selectedMember.details}</p>

              <div className="management-expertise">
                {selectedMember.expertise.map((item) => (
                  <small key={item}>{item}</small>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}